import { NavigationEnd, Router } from '@angular/router';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppInitService } from './digigov/services/app-init.service';
import { AuthenticationService } from './digigov/services/authentication.service';
import { PreLoginService } from './digigov/dg_core/pre-login/pre-login.service';
import { Observable, of } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import DisableDevtool from 'disable-devtool';
import { AuthType } from './digigov/constants/digigov.constants';
import { StompWebsocketService } from './digigov/services/stomp-websocket.service';
import Swal from 'sweetalert2';
import { MainService } from './digigov/dg_core/main/main.service';
import { IdleService } from './idle.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'customAngular';
  isDoneLoading$: Observable<boolean>;
  hasLoggedIn = false;
  ORIGIN: string = null;
  digigovCurrentTab = 0;
  broadCastChannelSessionTimeout = new BroadcastChannel("SESSION_TIMEOUT");
  constructor(
    public translate: TranslateService,
    public appInitService: AppInitService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private customServie: TranslateService,
    public dgPreLoginService: PreLoginService,
    private oauthService: OAuthService,
    private _el:ElementRef,
    private stompWebStockService:StompWebsocketService,
     private mainService:MainService,
     private idleService:IdleService
  ) {

    idleService.setupSessionIdle(14,1);
    idleService.reset();
    this.isDoneLoading$ = this.appInitService.isDoneLoading$;

    if (this.appInitService.appConfig?.authType === AuthType.OATUH2) {
      this.appInitService.receivedOauthToken$.subscribe((r) => {
        if (r) {
          this.afterLogin();
        }
      });
    }
    if (this.appInitService.appConfig?.disableDevTools) {
      DisableDevtool({
        url: this.appInitService.appConfig.unauthorizedUrl,
        timeOutUrl: '/',
        ondevtoolopen: () => {
          if (
            this.authenticationService.currentUserValue &&
            this.authenticationService.loggedInUser
          ) {
            this.authenticationService.logout();
          } else {
            alert('Please close developer tools.');
          }
        },
      });
    }
  }
  ngOnDestroy(): void {
    localStorage.clear();
  }
  ngOnInit(): void {

    this.broadCastChannelSessionTimeout.onmessage= (event) => {
      if(event.data.sessionTimeout == true)
      {
        this.authenticationService.logout();
      }
    }

    if(new URL(window.location.href).searchParams.has("origin")) {
      let origin = new URL(window.location.href).searchParams.get("origin");
      this.ORIGIN = origin;
    }else{
      this.ORIGIN = "DIGIGOV";
    }
    this._multipleTabsConfiguration_();

    this._el.nativeElement.removeAttribute("ng-version");
    if (this.appInitService.appConfig.authType === AuthType.OATUH2) {
      if (this.oauthService.hasValidAccessToken()) {
        this.hasLoggedIn = true;
      }
    } else if (this.appInitService.appConfig.authType === AuthType.PRE_AUTH) {
      this.appInitService.isDoneLoadingSubject$.next(false);
      this.appInitService.isAfterLoginDone = false;
      this.afterLogin();
    }
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.appInitService.getUserPreference().subscribe();

   
  }
  afterLogin(): void {
    if (!this.hasLoggedIn) {
      this.authenticationService.justLogin = localStorage.getItem('justLogin')
        ? JSON.parse(localStorage.getItem('justLogin'))
        : true;
      this.appInitService.getLogoId();
      this.customServie.setDefaultLang(this.appInitService.language);
      let loginObs = this.authenticationService.coreLoginInitiazationAfterSSO();
      if (this.appInitService.appConfig.authType === AuthType.PRE_AUTH) {
        loginObs = of(null);
      }
      loginObs.subscribe(
        () => {
          this.hasLoggedIn = true;
          this.appInitService.getUserPreference().subscribe(
            () => {
              this.customServie.setDefaultLang(this.appInitService.language);
              this.appInitService.getConfigurableFields().subscribe(
                () => {
                  this.appInitService.getMicroserviceDtls();
                  this.appInitService.isAfterLoginDone = true;
                  this.appInitService.isDoneLoadingSubject$.next(true);

                  this.dgPreLoginService.preLoginUser = null;
                  const oauthState = JSON.parse(
                    decodeURIComponent(this.oauthService.state)
                  );
                  const originalUrl = oauthState.originalUrl;
                  this.router.navigateByUrl(
                    originalUrl
                      ? originalUrl
                      : this.appInitService.appConfig.afterLoginLandingUrl
                  );
                },
                () => {
                  console.error('Could not fetch labels');
                  this.appInitService.isAfterLoginDone = true;
                  this.appInitService.isDoneLoadingSubject$.next(true);
                }
              );
            },
            () => {
              console.error('Could not get languaage');
              this.appInitService.isAfterLoginDone = true;
              this.appInitService.isDoneLoadingSubject$.next(true);
            }
          );
        },
        () => {
          console.error('Could not login');
          this.appInitService.isAfterLoginDone = true;
          this.appInitService.isDoneLoadingSubject$.next(true);
        }
      );
    }
  }

_multipleTabsConfiguration_(){
  broadCastChannel.onmessage = (event) => {
    console.log("Data is")
    console.log(window.location.href)
    console.log(sessionStorage)
    console.log(localStorage)
    if(event.data.origin == "DIGIGOV" && event.data.identifier == "DIGIGOV"){
      if(this.ORIGIN == "DIGIGOV"){
        if(this.digigovCurrentTab == 0){
          this.digigovCurrentTab = 1;
        }else if(this.digigovCurrentTab == 1){
          Swal.fire({
            icon: "warning",
            iconColor: "#1864ab",
            title: "Multiple tabs not allowed",
            text: "It was detected that a new tab was opened. Hence you need to close this tab!",
            // confirmButtonText: "OK",
            // confirmButtonColor: "#1864ab",
            allowOutsideClick: false,
          }).then(
            result => {
              if(result.isConfirmed == true){
                window.close();
              }//else if(result.isDismissed == true){
                // window.close();
              //}
            }
          );
        }
      }
    }
  };
}



}


export const broadCastChannel = new BroadcastChannel("AUTHENTICATION")
export const broadCastChannelLogout = new BroadcastChannel("DGGOV_LOGOUT");